import { useLayout } from '@approvalmax/ui/src/components';
import { hocs as pageHocs } from 'modules/page';
import { useDispatch } from 'modules/react-redux';
import { useUnmount } from 'react-use';

import { leavePage } from './actions';
import useCreateRequestPageData from './hooks/useCreateRequestPageData';
import { usePageRedesign } from './hooks/usePageRedesign';
import { Loading } from './loading';
import { LoadingOld } from './loadingOld';

const Page = () => {
    const dispatch = useDispatch();
    const { isPageRedesign } = usePageRedesign();

    useUnmount(() => {
        dispatch(leavePage());
    });

    useLayout({ hasHeader: true });
    useCreateRequestPageData();

    return <>{isPageRedesign ? <Loading /> : <LoadingOld />}</>;
};

export default pageHocs.withProtected({ Page });
